// extracted by mini-css-extract-plugin
export default {"updateProfileBtnWrapper":"wjtqRFD7ERUg1E57GCRQ","updateProfileBtn":"MYo0Ux8EbL2HfpLdALUG"};